import type { RootState } from 'state/modules';

/**
 * Get a single brokerage from state by id.
 * @param {Object} state
 * @param {Number} id
 * @return {Object}
 */
// Denormalized API blob whose view type each consumer declares for itself.
export const getById = (state: RootState, id: string | number): any => state.brokerages.byId[id];

/**
 * Get the uploading state.
 * @param {Object} state
 * @return {Boolean}
 */
export const isUploading = (state: RootState) => state.brokerages.isUploading;
